import { Icon } from '@chakra-ui/icons';
import { useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const LinkedInIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="-4 -5 70 73" {...rest} __css={styles}>
      <desc id="svgdescLinkedIn">LinkedIn Logo</desc>
      <path className="accent" d="M10.305 11.119h43.119v42.847H10.305z" />
      <path
        className="background"
        d="M12.8 51.2V24.384h8.192V51.2H12.8m8.448-34.24c.064 2.304-1.664 4.16-4.416 4.16-2.56 0-4.224-1.856-4.224-4.16 0-2.368 1.728-4.16 4.352-4.16s4.288 1.792 4.288 4.16M42.752 51.2V36.352c0-3.456-1.152-5.824-4.16-5.824-2.24 0-3.584 1.6-4.224 3.136-.192.576-.256 1.344-.256 2.112V51.2H25.92V32.96c0-3.328-.128-6.144-.192-8.576h7.104l.384 3.776h.128c1.088-1.792 3.776-4.352 8.192-4.352 5.376 0 9.472 3.648 9.472 11.584V51.2h-8.256M64 5.632C64 2.56 61.44 0 58.368 0H5.632C2.56 0 0 2.56 0 5.632v52.736C0 61.44 2.56 64 5.632 64h52.736C61.44 64 64 61.44 64 58.368V5.632"
      />
    </Icon>
  );
};

export default LinkedInIcon;
